<template>
  <div v-if="isShowPage" class="edit">
    <van-nav-bar :left-arrow="!$route.query.fromapp" @click-left="back">
      <template slot="title">
        <div class="title">
          <span :class="['tab', { on: activeTab === 'sale' || activeTab === 1 }]" @click="setSale">{{ lang.titleSale }}</span>
          <span :class="['tab', { on: activeTab === 'rent' || activeTab === 2 }]" @click="setRent">{{ lang.titleRent }}</span>
        </div>
      </template>
    </van-nav-bar>

    <!-- 列表数据 sale -->
    <div v-if="activeTab == 'sale'">
      <div class="sale" v-if="saleShowList">
        <van-list v-model="loading" :finished="finished" @load="saleOnLoad" :loading-text="lang.loadingText">
          <houseList :house-list="salePropertylist" :lang="lang" :type="type" :isDisable="isDisable"></houseList>
        </van-list>
      </div>
      <div class="nodata" v-else>
        <img src="//static.house730.com/m/images/none_col.png" class="img" />
        <p>{{ lang.noHome }}</p>
      </div>
    </div>

    <!-- 列表数据 rent -->
    <div v-if="activeTab == 'rent'">
      <div class="rent" v-if="rentShowList">
        <van-list v-model="loading" :finished="finished" @load="rentOnLoad" :loading-text="lang.loadingText">
          <houseList :house-list="rentPropertylist" :lang="lang" :type="type" :isDisable="isDisable"></houseList>
        </van-list>
      </div>
      <div class="nodata" v-else>
        <img src="//static.house730.com/m/images/none_col.png" class="img" />
        <p>{{ lang.noHome }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import pub from '../../common/public';
import houseList from '../../src/components/house-list';
import lang from './../../common/language/editProperty';
import { mapState, mapMutations } from 'vuex';
export default {
  metaInfo: { 
    title: lang.editProperty,
    meta: [{
      name: 'description',
      content: lang.editProperty_description
    }]
  },
  data() {
    return {
      isShowPage: false,
      lang,
      activeTab: '',
      salePropertylist: [],
      rentPropertylist: [],
      userInfo: {},
      loading: false,
      finished: false,
      salePageIndex: 1,
      rentPageIndex: 1,
      listCount: 0,
      rentShowList: true,
      saleShowList: true,
      subCategoryText: '',
      app: '',
      isPc: false,
      isDisable: true,
    };
  },
  computed: {
    ...mapState(['type']),
  },
  components: {
    houseList,
  },
  created() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcPassport}zh-cn/my-items/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcPassport}en-us/my-items/`;
      } else {
        location.href = `${pub.config.pcPassport}my-items/`;
      }
    } else {
      this.isShowPage = true
    }
    // 管理后台禁用刊登/管理楼盘
    this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
      if (res.data.code == 0 && res.data.result) {
        this.userInfo = res.data.result;
        console.log("userInfo22222",this.userInfo)
        if (this.userInfo.isAllowPublishProperty === false) {
          this.isDisable = false
        }
      }
    });
    // 管理后台停用当前代理
    this.axios.get(this.pub.getApi().GetAgentCompanyById).then((res) => {
      if (res.data.code == 0 && res.data.result) {
        this.userInfo = res.data.result;
        if (this.userInfo.isAllowPublishProperty === false) {
          this.salePageIndex = 0;
          this.rentPageIndex = 0;
          return this.$dialog({ title: lang.stop, confirmButtonText: lang.confirm }).then(() => this.$router.push('/'));
        }
      }
    });
    if (this.type && !this.$route.query.url) {
      if (this.type == 1) {
        this.activeTab = 'sale';
      } else if (this.type == 2) {
        this.activeTab = 'rent';
      } else {
        this.activeTab = this.type;
        return;
      }
    } else if (this.$route.query && this.$route.query.url && typeof this.$route.query.url === 'string' && this.$route.query.url.indexOf('rent') > -1) {
      console.log("ccc22222333")
      this.activeTab = 'rent';
    } else if (this.$route.query && this.$route.query.url && typeof this.$route.query.url === 'string' && this.$route.query.url.indexOf('buy') > -1) {
      console.log("ccc22222444")
      this.activeTab = 'sale';
    } else {
      this.activeTab = 'sale';
    }
  },
  watch: {
    activeTab(type) {
      this.salePageIndex = 1;
      this.rentPageIndex = 1;
      this.activeTab = type;
      this.salePropertylist = [];
      this.rentPropertylist = [];
      this.loading = true;
      this.finished = false;
      if (this.activeTab == 'sale') {
        //有时过快会导致已删除楼盘仍然出现
        setTimeout(() => {
          this.saleOnLoad();
        }, 500);
      } else {
        this.rentOnLoad();
      }
    },
  },
  methods: {
    ...mapMutations(['setType', 'clearAll']),
    setSale() {
      this.activeTab = 'sale';
      this.setType('sale');
    },
    setRent() {
      this.activeTab = 'rent';
      this.setType('rent');
    },
    back() {
      this.store.state.saleableArea = '';
      if (this.$route.query.url) {
        window.location.href = location.origin + this.$route.query.url;
      } else {
        this.$router.push('/');
      }
    },
    saleOnLoad() {
      this.axios
        .post(this.pub.getApi().SearchUserPublishProperty, {
          rentalType: 'sale',
          pageIndex: this.salePageIndex,
          pageCount: 10,
          order: 'PublishTimeDesc',
        })
        .then((res) => {
          if (res.data.code === 0 && res.data.result.data) {
            if (res.data.result.count === 0) {
              return (this.saleShowList = false);
            } else {
              this.saleShowList = true;
            }
            this.salePropertylist = this.salePropertylist.concat(res.data.result.data);
            this.listCount = res.data.result.count;
            this.loading = false;
            if (this.salePageIndex == 1 && this.listCount > 0 && this.activeTab == 'sale') {
              if (this.isShowPage) {
                this.$toast(lang.find + this.listCount + lang.num);
              }
            }
            this.salePageIndex++;
            if (this.salePropertylist.length >= this.listCount) {
              this.finished = true;
            }
          }
        })
        .catch((err) => {});
    },
    rentOnLoad() {
      this.axios
        .post(this.pub.getApi().SearchUserPublishProperty, {
          rentalType: 'rent',
          pageIndex: this.rentPageIndex,
          pageCount: 10,
          order: 'PublishTimeDesc',
        })
        .then((res) => {
          if (res.data.code === 0 && res.data.result.data) {
            if (res.data.result.count === 0) {
              return (this.rentShowList = false);
            } else {
              this.rentShowList = true;
            }
            this.rentPropertylist = this.rentPropertylist.concat(res.data.result.data);
            this.listCount = res.data.result.count;
            if (this.rentPageIndex == 1 && this.listCount > 0 && this.activeTab == 'rent') {
              if (this.isShowPage) {
                this.$toast(lang.find + this.listCount + lang.num);
              }
            }
            this.rentPageIndex++;
            this.loading = false;
            if (this.rentPropertylist.length >= this.listCount) {
              this.finished = true;
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.edit {
  text-align: left;
  height: 100%;
  background-color: #fff;
}
.title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  border: 0.5px solid rgba(41, 38, 48, 0.32);
  height: 30px;
  display: flex;
  line-height: 30px;
  border-radius: 100px;
  width: 198px;
  box-sizing: border-box;
  overflow: hidden;
  .tab {
    display: inline-block;
    width: 99px;
    background-color: #fff;
    font-weight: normal;
    color: #333 !important;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 15px;
  }
  span.on {
    width: 99px;
    background: #333333;
    color: #fff !important;
  }
}
/deep/ .van-nav-bar__title {
  max-width: none;
}
// tab
.sale,
.rent {
  // padding: 15px;
  height: 100%;
}
.nodata {
  margin: 120px auto;
  text-align: center;
  font-size: 14px;
  img {
    width: 120px;
  }
}
</style>
